import { render, staticRenderFns } from "./Pannel.vue?vue&type=template&id=0334cd28&scoped=true&"
import script from "./Pannel.vue?vue&type=script&lang=js&"
export * from "./Pannel.vue?vue&type=script&lang=js&"
import style0 from "./Pannel.vue?vue&type=style&index=0&id=0334cd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334cd28",
  null
  
)

export default component.exports